exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ninput[readonly].my-dropdown {\n  background-color: transparent;\n  padding-right: 34px;\n  font-size: 14px;\n  color: #292929;\n}\n.my-dropdown-arrow {\n  position: absolute;\n  display: block;\n  top: 50%;\n  right: 5px;\n  transform: translate(-50%, -50%);\n  height: 8px;\n}\n\n", ""]);

// exports
